import { Role } from '@/core/security/Role';
import { RealmsModule } from '@/store/modules/realms/realms.store';
import { UserViewObject, UserLogin, UserPermission, UserSettingsViewObject, UserRealm, CoreFileAccess } from '@/types/apiServerContract';

class User implements UserViewObject {
    constructor(
		public id: string,
		public userName: string,
		public accountId: number,
		public currentLogin: UserLogin,
		public email: string,
		public emailHidden: boolean,
		public fileAccess: CoreFileAccess[],
		public joinDate: Date,
		public lastLogin: UserLogin,
		public location: string,
		public lockoutEnd: Date,
		public lockoutEnabled: boolean,
		public permissions: UserPermission[],
		public realms: UserRealm[],
		public roles: Role[],
		public settings: UserSettingsViewObject[],
		public totalVotes: number,
		public hasAcceptedDonationTerms: boolean
    ) {}

    get IsAdmin(): boolean {
        return this.IsSuperAdmin || this.roles.includes(Role.Administrator);
    }

    get IsSuperAdmin(): boolean {
        return this.roles.includes(Role.SuperAdmin);
    }

    public HasRole(roles: Role[]): boolean {
        return this.IsSuperAdmin || this.roles.some(x => roles.indexOf(x) >= 0);
    }

    public HasPermission(permissions: string[]): boolean {
        const realmId = RealmsModule.activeRealmId;

        return this.IsSuperAdmin || this.permissions.some(x => permissions.includes(x.permissionId) && x.realmId === realmId);
    }
}

export { User };
